import type { SVGProps } from 'react';

export const CaretUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7064 6.29318C12.3157 5.90252 11.6824 5.90252 11.2917 6.29318L2.95974 14.6265C2.56907 15.0172 2.56907 15.6505 2.95974 16.0412C3.35041 16.4318 3.98374 16.4318 4.3744 16.0412L12.0011 8.41451L19.6277 16.0412C19.8224 16.2358 20.0784 16.3345 20.3344 16.3345C20.5904 16.3345 20.8464 16.2372 21.041 16.0412C21.4317 15.6505 21.4317 15.0172 21.041 14.6265L12.7077 6.29318H12.7064Z"
      fill="currentColor"
    />
  </svg>
);
